<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="px-6 py-4">
  <!-- Header -->
  <div class="flex justify-content-between mb-4 align-items-center">
    <p class="text-xl font-semibold">{{ 'layout.configurations.currency.title' | translate }}</p>
       <div class="flex gap-2 align-items-center">

      <!-- Save Order button - only visible when order has changed -->
      <p-button
        *ngIf="orderChanged"
        icon="pi pi-save"
        label="{{ 'layout.configurations.currency.saveOrder' | translate }}"
        severity="warning"
        (onClick)="saveOrder()"
        [pTooltip]="'layout.configurations.currency.saveOrderTooltip' | translate">
      </p-button>

      <!-- Reset Order button -->
      <p-button
        icon="pi pi-refresh"
        label="{{ 'layout.configurations.currency.resetOrder' | translate }}"
        severity="secondary"
        [outlined]="true"
        (onClick)="resetOrder()"
        [pTooltip]="'layout.configurations.currency.resetOrderTooltip' | translate">
      </p-button>

      <p-button
      *emPermission="Permission.CONFIG_INVOICING"
        icon="pi pi-plus"
        [label]="'layout.configurations.currency.add' | translate"
        (onClick)="onAddCurrency()"
        severity="success">
      </p-button>
    </div>
  </div>

  <div class="center-rate-currency-panel mb-3">
    <label for="centerRateCurrency" class="center-rate-currency-label">
      {{ 'layout.configurations.currency.centerRateCurrency.label' | translate }}
    </label>
    <p-dropdown
      inputId="centerRateCurrency"
      [options]="activeCurrencies"
      [(ngModel)]="selectedCenterRateCurrencyId"
      optionLabel="currencyName"
      optionValue="id"
      [disabled]="centerRateCurrencyLoading || centerRateCurrencySaving"
      [placeholder]="'layout.configurations.currency.centerRateCurrency.placeholder' | translate"
      styleClass="center-rate-currency-dropdown"
      appendTo="body"
      (onChange)="onCenterRateCurrencyChange($event.value)">
    </p-dropdown>
  </div>

  <!-- Drag hint banner -->
  <div class="flex align-items-center gap-2 mb-3 p-2 border-round"
       style="background: #f0f7ff; border: 1px solid #bcd4f8; color: #2563eb; font-size: 0.85rem;">
    <i class="pi pi-arrows-v"></i>
    <span>{{ 'layout.configurations.currency.dragHint' | translate }}</span>
  </div>

  <!-- Table -->
  <p-table
    [value]="currencies"
    [paginator]="true"
    [rows]="10"
    [loading]="isLoading"
    styleClass="w-full p-datatable-sm">

    <ng-template pTemplate="header">
      <tr>
        <th class="bg-white w-3rem text-center" style="color: #aaa;">
          <i class="pi pi-bars" [title]="'layout.configurations.currency.dragToReorder' | translate"></i>
        </th>
        <th pSortableColumn="currencyName" class="bg-white">
          {{ 'layout.configurations.currency.currencyName' | translate }}
          <p-sortIcon field="currencyName"></p-sortIcon>
        </th>
        <th pSortableColumn="status" class="bg-white">
          {{ 'layout.configurations.currency.status' | translate }}
          <p-sortIcon field="status"></p-sortIcon>
        </th>
      <th *emPermission="Permission.CONFIG_INVOICING" class="bg-white w-10rem text-center">
          {{ 'layout.configurations.currency.actions' | translate }}
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-currency let-rowIndex="rowIndex">
      <tr draggable="true"
        (dragstart)="onDragStart(rowIndex)"
        (dragover)="onDragOver($event)"
        (dragenter)="onDragEnter(rowIndex)"
        (drop)="onDrop($event)"
        (dragend)="onDragEnd()"
        style="cursor: grab;"
        class="currency-draggable-row"
        [class.drag-over]="dragOverIndex === rowIndex && dragOverIndex !== dragIndex">
        <!-- Drag handle cell -->
        <td class="text-center" style="color: #aaa;">
          <i class="pi pi-bars"></i>
        </td>
        <td>{{ currency.currencyName }}</td>
        <td>
          <p-tag 
            [value]="getStatusLabel(currency.status)" 
            [severity]="getSeverity(currency.status)">
          </p-tag>
        </td>
      <td *emPermission="Permission.CONFIG_INVOICING" class="text-center">
          <p-button
            icon="pi pi-pencil"
            [outlined]="true"
            class="mr-2"
            severity="info"
            (onClick)="onEditCurrency(currency)"
            [pTooltip]="'layout.configurations.currency.editcurrency' | translate">
          </p-button>
          <p-button
            icon="pi pi-trash"
            [outlined]="true"
            severity="danger"
            (onClick)="onDeleteCurrency($event, currency)"
            [pTooltip]="'layout.configurations.currency.delete.title' | translate">
          </p-button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="text-center">
          {{ 'layout.configurations.currency.noData' | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
